<div class="container-fluid">
  <div class="row mt-3">
    <div class="col">
      <h5>Bypass Installation</h5>
    </div>
  </div>
  <form-workflow
    [form]="form"
    [sectionNumber]="4"
    [amendmentSectionNumbers]="[12]"
    [service]="service"
  >
  </form-workflow>
</div>
